var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bool)?_c('span',{staticClass:"glyphicon glyphicon-ok",staticStyle:{"color":"#3c763d"},attrs:{"aria-hidden":"true","aria-label":"true"}}):_c('span',{staticClass:"glyphicon glyphicon-remove",staticStyle:{"color":"#a94442"},attrs:{"aria-hidden":"true","aria-label":"false"}})
}
var staticRenderFns = []

export { render, staticRenderFns }